import { Tooltip } from '@unbrace/components';
import { Download } from 'components/icons';
import * as React from 'react';
import styled from 'styled-components';

type Props = {
  to: string;
  text: string;
};

const DownloadLink: React.FunctionComponent<Props> = ({ to, text }: Props) => {
  return (
    <Tooltip content={text} boxed>
      <Wrapper href={to}>
        <div>{text}</div>
        <Download />
      </Wrapper>
    </Tooltip>
  );
};

const Wrapper = styled.a`
  display: flex;
  align-items: center;
  text-decoration: underline;
  color: ${(props) => props.theme.palette.primary.shade4};
  max-width: 100%;
  overflow: hidden;

  div {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
  }

  svg {
    margin-left: 10px;
    height: 16px;
    width: 16px;
    flex-shrink: 0;
  }
`;

export default DownloadLink;
